<app-section-template
  [sectionTitle]="'Popular'|translate"
  theme="grey">

  <div class="wrapper">

    <!--    TODO: Check that BE type numeration matches ours-->
    @for (item of data(); track item) {
      <div class="publication"
           [ngClass]="{
        'publication-standard': item.type === 'Standard',
        'publication-publication': item.type === 'Publication',
        'publication-resource': item.type === 'Resource',
        'publication-project': item.type === 'Project',
        'publication-news': item.type === 'News',
        'publication-meeting': item.type === 'Meeting',
        'publication-jurisdictions': item.type === 'Jurisdictions',
      }">
        <a [href]="getUrl(item)">
          <div class="publication-type">{{ item.type }}</div>
          <div class="publication-main">
            <div class="publication-title">{{ item.title }}</div>
            <div class="publication-desc" [innerHTML]="item.description | removeHtml"></div>
          </div>
          <div
            class="publication-date">{{ HELPER.formatDateWithLocalizedMonth(item.publishDate) }}
          </div>
        </a>
      </div>
    }

  </div>

</app-section-template>
